import React from 'react';
import PropTypes from 'prop-types';
import {get} from 'lodash';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';

export { default as SwipeableTab } from './SwipeableTab';

export default class SwipeableTabs extends React.Component {
  static propTypes = {
    tabIndex: PropTypes.number,
    handleChangeTab: PropTypes.func,
    tabsClassName: PropTypes.string,
    tabsStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    tabsProps: PropTypes.object,
    swipeableViewsClassName: PropTypes.string,
    swipeableViewsStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    swipeableViewsProps: PropTypes.object,
    children: PropTypes.node.isRequired
  }

  static defaultProps = {
    tabsComponentProps: {}
  }

  state = {
    tabIndex: 0
  }

  componentWillReceiveProps(nextProps) {
    const {tabIndex} = nextProps;

    if (tabIndex) {
      this.setTabIndex(tabIndex);
    }
  }

  setTabIndex(tabIndex) {
    this.setState({tabIndex});
  }

  handleChangeTab = (event, tabIndex) => {
    this.handleSwipe(tabIndex);
  }

  handleSwipe = (tabIndex) => {
    const {handleChangeTab} = this.props;

    if (handleChangeTab) {
      handleChangeTab(tabIndex);
    }

    this.setTabIndex(tabIndex);
  }

  renderTab = (swipleableTab, index) => {
    const tabComponent = swipleableTab.props.tabComponent;

    if (tabComponent) {
      return tabComponent;
    }

    const {
      id,
      tabLabel,
      tabClassName,
      tabStyle,
      tabProps
    } = swipleableTab.props;

    const key = (id ? `${id}_${index}` : index);

    return (
      <Tab
        id={id}
        key={key}
        label={tabLabel}
        className={tabClassName}
        style={tabStyle}
        {...tabProps}
      />
    );
  }

  renderTabs() {
    return this.props.children.map(this.renderTab);
  }

  render() {
    const {
      tabsClassName,
      tabsStyle,
      tabsProps,
      swipeableViewsClassName,
      swipeableViewsStyle,
      swipeableViewsProps
    } = this.props;

    return (
      <React.Fragment>
        <Tabs
          value={this.state.tabIndex}
          onChange={this.handleChangeTab}
          className={tabsClassName}
          style={tabsStyle}
          {...tabsProps}
        >
          {this.renderTabs()}
        </Tabs>

        <SwipeableViews
          index={this.state.tabIndex}
          onChangeIndex={this.handleSwipe}
          className={swipeableViewsClassName}
          style={swipeableViewsStyle}
          {...swipeableViewsProps}
        >
          {this.props.children}
        </SwipeableViews>
      </React.Fragment>
    );
  }
}
